<template>
  <div class="section-title section-title-internal">
    <div class="section-title-icon">
      <router-link to="/vinculo-acompanhamento">
        <button><i class="icofont-reply"></i> <span>Voltar</span></button>
      </router-link>
    </div>
    <div class="section-title-info">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
    </div>
    <div class="section-title-btn-help">
      <!-- <button @click="exibirModalAjuda()">
        <i class="icofont-youtube-play"></i> <span>Ajuda</span>
      </button> -->
      <!-- <button><i class="icofont-youtube-play"></i> Ajuda</button> -->
    </div>
    <ModalAjuda
      v-if="showModalAjuda"
      @close-modal-ajuda="closeModalAjuda()"
      :card_title="title"
      :linkvideo="linkvideoajuda"
    >
    </ModalAjuda>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalAjuda from './ModalAjuda'

export default {
  name: 'SectionTitle',
  components: {
    ModalAjuda,
  },
  // computed: mapState(['modal_ajuda']),
  computed: {
    modal_ajuda() {
      if (this.$store.getters.getModalAjuda(this.title) == undefined) {
        return false
      }
      return this.$store.getters.getModalAjuda(this.title)
    },
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    linkvideoajuda: {
      type: String,
      default: '',
    },
  },
  mounted() {
    // this.exibirModalAjuda();
  },
  data() {
    return {
      showModalAjuda: null,
      title: 'Condições Saúde',
      description: 'Situação e condições de saúde por cidadão',
    }
  },
  methods: {
    exibirModalAjuda() {
      let modalAjudaStore = this.$store.getters.getModalAjuda('Comorbidades')
      if (
        modalAjudaStore != undefined &&
        modalAjudaStore.active == false &&
        this.showModalAjuda != false
      ) {
        this.showModalAjuda = false
      } else {
        this.showModalAjuda = true
        let modal = {
          active: true,
          card: this.title,
        }
        this.$store.commit('setModalAjuda', modal)
      }
    },
    closeModalAjuda() {
      this.showModalAjuda = false
    },
  },
}
</script>

<style></style>
